import { useEventContextV2 } from "~/app/providers";
import { HostTooltipClickable } from "~/components/v3/events-components/HostedByV3";
import { UserAvatar } from "~/components/v4/shadcn/UserAvatar";
import {
    AddHostButton,
    DeleteHostButton,
} from "../manage/hosts/HostPageActions";
import { generateRandomName } from "~/utils/constants";
import { cn } from "~/utils/fontsConfig";
import { If } from "~/components/v3/Conditional";
import { CustomizableLayout } from "~/types/CustomizableLayout";

export const EventHosts = ({
    isAuthorized,
    className,
    customization,
}: {
    isAuthorized: boolean;
    className?: string;
    customization?: CustomizableLayout & {
        sideCardClassName?: string;
    };
}) => {
    const event = useEventContextV2();

    return (
        <div
            className={cn(
                "flex flex-col gap-5 rounded-md bg-v3-N-600 p-6",
                className,
            )}
        >
            <div className="flex items-center justify-between">
                <h2
                    className={cn("text-[20px]", customization?.labelClassName)}
                >
                    Hosts
                </h2>
                <If condition={!!isAuthorized}>
                    <AddHostButton
                        eventId={event.id}
                        communityId={event.communityId}
                        customization={customization}
                    />
                </If>
            </div>
            <div className="flex flex-col gap-2">
                {event.hosts.length === 0 && (
                    <div className="flex flex-col gap-2">
                        <p
                            className={cn(
                                "text-base text-v3-N-300",
                                customization?.descriptionClassName,
                            )}
                        >
                            No hosts available yet. Apply above to become a
                            host.
                        </p>
                    </div>
                )}

                {event.hosts.map((host) => (
                    <div
                        key={host.id}
                        className={cn(
                            "flex items-center justify-between rounded-[10px] bg-v3-N-500 px-4 py-3 text-white",
                            customization?.sideCardClassName,
                        )}
                    >
                        <HostTooltipClickable
                            user={host.user}
                            triggerClassName="flex items-center gap-3"
                        >
                            <UserAvatar
                                user={host.user}
                                className="h-10 w-10"
                            />
                            <div className="flex items-center gap-2">
                                <span className="text-base">
                                    {!!host.user.name
                                        ? host.user.name
                                        : generateRandomName(host.user.id)}
                                </span>
                                {host.user.id === event.creatorId && (
                                    <span className="max-h-fit rounded-lg bg-v3-clover px-3 py-1 text-sm">
                                        Creator
                                    </span>
                                )}
                            </div>
                        </HostTooltipClickable>

                        {isAuthorized && (
                            <DeleteHostButton
                                eventId={event.id}
                                hostId={host.id}
                                hostUserId={host.user.id}
                                isCreator={host.user.id === event.creatorId}
                                isLastHost={event.hosts.length === 1}
                                eventSlug={event.slug}
                                customization={customization}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
